import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_ARTICLE_COMMISSION_MODEL,
    FAILURE_CREATE_ARTICLE_COMMISSION_MODEL,
    FAILURE_DELETE_ARTICLE_COMMISSION_MODEL,
    FAILURE_UPDATE_ARTICLE_COMMISSION_MODEL,
    REQUEST_ARTICLE_COMMISSION_MODEL,
    REQUEST_CREATE_ARTICLE_COMMISSION_MODEL,
    REQUEST_DELETE_ARTICLE_COMMISSION_MODEL,
    REQUEST_UPDATE_ARTICLE_COMMISSION_MODEL,
    SUCCESS_ARTICLE_COMMISSION_MODEL,
    SUCCESS_CREATE_ARTICLE_COMMISSION_MODEL,
    SUCCESS_DELETE_ARTICLE_COMMISSION_MODEL,
    SUCCESS_UPDATE_ARTICLE_COMMISSION_MODEL,
} from './actions';

export function articleCommissionModelReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_CREATE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_UPDATE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_UPDATE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_DELETE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_DELETE_ARTICLE_COMMISSION_MODEL:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
